import { nowInstant } from '@insio/dates';

/** Synthetic key for client-side list reconciliation before the server assigns
 * a real ID. Not stable across reloads — do not persist or send to the server. */
export function createId(prefix = 'new'): string {
  return `${prefix}-${nowInstant().epochMilliseconds}-${Math.random().toString(36).slice(2)}`;
}
